import BarChart from '../bar';
import { BarStackHorizontal } from './elements/bar-stack-horizontal';
import { BarStackHorizontalLabels } from './elements/bar-stack-horizontal-label';
import { BarStackHorizontalMarks } from './elements/bar-stack-horizontal-marks';
import { BarStackHorizontalScalesElement } from './elements/bar-stack-horizontal-scale';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HorizontalStackBarChart(_ref) {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs(BarChart, {
    ...props,
    children: [/*#__PURE__*/_jsx(BarStackHorizontalScalesElement, {}), /*#__PURE__*/_jsx(BarStackHorizontal, {}), /*#__PURE__*/_jsx(BarChart.elements.TooltipOverlay, {
      horizontal: true
    }), /*#__PURE__*/_jsx(BarChart.elements.TooltipEmitter, {
      horizontal: true
    }), /*#__PURE__*/_jsx(BarChart.elements.Grid, {
      rowLineStyle: "hidden",
      columnLineStyle: "solid"
    }), /*#__PURE__*/_jsx(BarChart.elements.AxisLeftLine, {
      hide: true
    }), /*#__PURE__*/_jsx(BarChart.elements.AxisLeftTick, {
      hide: true
    }), /*#__PURE__*/_jsx(BarChart.elements.AxisBottomTick, {
      hide: true
    }), /*#__PURE__*/_jsx(BarChart.elements.AxisBottomLine, {
      hide: true
    }), children]
  });
}
HorizontalStackBarChart.elements = {
  ...BarChart.elements,
  Scales: BarStackHorizontalScalesElement,
  Marks: BarStackHorizontalMarks.Component,
  MarkLabels: BarStackHorizontalLabels.Component
};